/* ============================================================
   NATTA Form — „Odmah na stanju" (sections/natta-na-stanju.liquid)
   Vlasnik, 12. 10. 2026. Svaka kartica nosi JSON sa bojama i velicinama
   koje su na stanju; ovdje se bira boja i velicina, filtrira po velicini
   i vrsti, dodaje u korpu (NattaCart iz natta.js) i otvara tabela
   velicina iz SizeMind-a.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-natta-ns]');
  if (!root || root.dataset.nsInit) return;
  root.dataset.nsInit = '1';

  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL+'];
  var state = { size: 'all', type: 'all' };

  function money(cents) {
    if (window.NattaMoney && window.NattaMoney.format) return window.NattaMoney.format(cents);
    return 'KM ' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // „M/L" pokriva i M i L; XXL = 2XL; sve od 3XL navise je jedna grupa.
  function norm(s) {
    return String(s || '').split('/').map(function (x) {
      x = x.trim().toUpperCase();
      if (x === 'XXL') return '2XL';
      if (/^[3-9]XL$/.test(x)) return '3XL+';
      return x;
    });
  }
  // Slicica boje je 40x53 — 600px slika kartice bi bila 10x vise podataka.
  function thumb(u) {
    return /[?&]width=\d+/.test(u || '') ? u.replace(/([?&]width=)\d+/, '$1120') : u;
  }
  function fits(s, want) {
    return want === 'all' || norm(s).indexOf(want) !== -1;
  }
  function plural(n) {
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return n + ' model na stanju';
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return n + ' modela na stanju';
    return n + ' modela na stanju';
  }

  /* ---------- kartice ---------- */
  var cards = Array.prototype.map.call(root.querySelectorAll('[data-ns-card]'), function (el) {
    var data;
    try { data = JSON.parse(el.querySelector('[data-ns-json]').textContent); } catch (e) { data = { colors: [] }; }
    return {
      el: el,
      colors: data.colors || [],
      type: el.getAttribute('data-type') || '',
      color: 0,
      size: null,
      img: el.querySelector('[data-ns-img]'),
      colorName: el.querySelector('[data-ns-colorname]'),
      price: el.querySelector('[data-ns-price]'),
      colorsBox: el.querySelector('[data-ns-colors]'),
      sizesBox: el.querySelector('[data-ns-card-sizes]'),
      add: el.querySelector('[data-ns-add]'),
      links: el.querySelectorAll('[data-ns-link]')
    };
  });

  function visibleColors(c) {
    return c.colors.map(function (col, i) { return i; }).filter(function (i) {
      return c.colors[i].sizes.some(function (s) { return fits(s.s, state.size); });
    });
  }
  function hasSizes(c) {
    return c.colors.some(function (col) { return col.sizes.some(function (s) { return s.s; }); });
  }
  function currentVariant(c) {
    var col = c.colors[c.color];
    if (!col) return null;
    if (!hasSizes(c)) return col.sizes[0];
    return col.sizes.filter(function (s) { return s.s === c.size; })[0] || null;
  }

  function renderCard(c) {
    var vis = visibleColors(c);
    if (vis.indexOf(c.color) === -1) c.color = vis.length ? vis[0] : 0;
    var col = c.colors[c.color];
    if (!col) return;
    if (c.size && !col.sizes.some(function (s) { return s.s === c.size; })) c.size = null;
    if (!c.size && state.size !== 'all') {
      var hit = col.sizes.filter(function (s) { return fits(s.s, state.size); })[0];
      if (hit) c.size = hit.s;
    }

    if (c.img && col.img && c.img.getAttribute('src') !== col.img) c.img.setAttribute('src', col.img);
    if (c.colorName) c.colorName.textContent = col.name;

    if (c.colorsBox) {
      c.colorsBox.innerHTML = vis.map(function (i) {
        var k = c.colors[i], on = i === c.color;
        return '<button type="button" class="n-ns-card__color' + (on ? ' is-active' : '') + '" role="radio" aria-checked="' + on +
          '" aria-label="' + esc(k.name) + '" title="' + esc(k.name) + '" data-ns-color="' + i + '"><img src="' + esc(thumb(k.img)) +
          '" alt="" width="40" height="53" loading="lazy"></button>';
      }).join('');
    }
    if (c.sizesBox) {
      c.sizesBox.innerHTML = col.sizes.map(function (s) {
        var on = s.s === c.size;
        var dim = state.size !== 'all' && !fits(s.s, state.size);
        return '<button type="button" class="n-ns-card__size' + (on ? ' is-active' : '') + (dim ? ' is-dim' : '') + '" role="radio" aria-checked="' + on +
          '" data-ns-size="' + esc(s.s) + '">' + esc(s.s) + '</button>';
      }).join('');
    }

    var v = currentVariant(c);
    if (c.price) c.price.textContent = money(v ? v.p : col.sizes[0].p);
    for (var i = 0; i < c.links.length; i++) {
      var base = c.links[i].getAttribute('href').split('?')[0];
      var vid = v ? v.id : col.sizes[0].id;
      c.links[i].setAttribute('href', base + '?variant=' + vid);
    }
    if (c.add && !c.add.classList.contains('is-busy') && !c.add.classList.contains('n-btn--added')) {
      if (v) {
        c.add.textContent = 'Dodaj u korpu' + (col.name ? ' · ' + col.name : '') + (v.s ? ' · ' + v.s : '');
        c.add.removeAttribute('aria-disabled');
      } else {
        c.add.textContent = 'Izaberite veličinu';
        c.add.setAttribute('aria-disabled', 'true');
      }
    }
  }

  function addToCart(c) {
    var v = currentVariant(c);
    if (!v) {
      // Bez izabrane velicine: istakni velicine umjesto tihog nicega.
      if (c.sizesBox) {
        c.sizesBox.classList.remove('is-ask');
        void c.sizesBox.offsetWidth;
        c.sizesBox.classList.add('is-ask');
        var first = c.sizesBox.querySelector('button');
        if (first) first.focus();
      }
      return;
    }
    if (!window.NattaCart || c.add.classList.contains('is-busy')) return;
    var btn = c.add;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Dodajem…';
    window.NattaCart.add([{ id: v.id, quantity: 1 }])
      .then(function () {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        btn.classList.add('n-btn--added');
        btn.textContent = '✓ Dodato u korpu';
        setTimeout(function () { btn.classList.remove('n-btn--added'); renderCard(c); }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        btn.textContent = 'Nije uspjelo — pokušajte ponovo';
        setTimeout(function () { renderCard(c); }, 2500);
      });
  }

  cards.forEach(function (c) {
    renderCard(c);
    c.el.addEventListener('click', function (e) {
      var colBtn = e.target.closest('[data-ns-color]');
      if (colBtn) { c.color = parseInt(colBtn.getAttribute('data-ns-color'), 10); c.size = null; renderCard(c); return; }
      var sizeBtn = e.target.closest('[data-ns-size]');
      if (sizeBtn) { c.size = sizeBtn.getAttribute('data-ns-size'); renderCard(c); return; }
      if (e.target.closest('[data-ns-add]')) { addToCart(c); return; }
      if (e.target.closest('[data-ns-chart-open]')) { openChart(c); }
    });
  });

  /* ---------- filteri ---------- */
  var sizeBox = root.querySelector('[data-ns-size-filter]');
  var typeBox = root.querySelector('[data-ns-type-filter]');
  var countEls = root.querySelectorAll('[data-ns-count]');
  var emptyEl = root.querySelector('[data-ns-empty]');

  var present = {};
  cards.forEach(function (c) {
    c.colors.forEach(function (col) { col.sizes.forEach(function (s) { norm(s.s).forEach(function (n) { present[n] = true; }); }); });
  });
  var sizeOpts = ['all'].concat(SIZE_ORDER.filter(function (s) { return present[s]; }));

  var typeCount = {};
  cards.forEach(function (c) { if (c.type) typeCount[c.type] = (typeCount[c.type] || 0) + 1; });
  var typeOpts = ['all'].concat(Object.keys(typeCount).sort(function (a, b) { return typeCount[b] - typeCount[a]; }));
  function typeLabel(t) {
    if (t === 'all') return 'Sve';
    if (/^kupa/i.test(t)) return 'Kupaći';
    return t;
  }

  function renderFilters() {
    if (sizeBox) {
      sizeBox.innerHTML = sizeOpts.map(function (s) {
        var on = state.size === s;
        return '<button type="button" class="n-ns__chip' + (on ? ' is-active' : '') + '" role="radio" aria-checked="' + on + '" data-ns-f-size="' + s + '">' + (s === 'all' ? 'Sve' : s) + '</button>';
      }).join('');
    }
    if (typeBox) {
      typeBox.innerHTML = typeOpts.map(function (t) {
        var on = state.type === t;
        return '<button type="button" class="n-ns__chip n-ns__chip--type' + (on ? ' is-active' : '') + '" aria-pressed="' + on + '" data-ns-f-type="' + esc(t) + '">' +
          esc(typeLabel(t)) + (t === 'all' ? '' : ' <span class="n-ns__chip-n">' + typeCount[t] + '</span>') + '</button>';
      }).join('');
    }
  }

  function apply() {
    var shown = 0;
    cards.forEach(function (c) {
      var ok = (state.type === 'all' || c.type === state.type) && visibleColors(c).length > 0;
      c.el.hidden = !ok;
      if (ok) { shown++; renderCard(c); }
    });
    for (var i = 0; i < countEls.length; i++) countEls[i].textContent = plural(shown);
    if (emptyEl) emptyEl.hidden = shown > 0;
    renderFilters();
  }

  root.addEventListener('click', function (e) {
    var s = e.target.closest('[data-ns-f-size]');
    if (s) {
      state.size = s.getAttribute('data-ns-f-size');
      // Novi filter = novi izbor: velicina se bira iznova, a „✓ Dodato"
      // sa prethodne kartice ne smije ostati na dugmetu.
      cards.forEach(function (c) { c.size = null; if (c.add) c.add.classList.remove('n-btn--added'); });
      apply();
      return;
    }
    var t = e.target.closest('[data-ns-f-type]');
    if (t) { state.type = t.getAttribute('data-ns-f-type'); apply(); }
  });

  /* ---------- tabela velicina (SizeMind) ---------- */
  var dlg = root.querySelector('[data-ns-chart]');
  var dlgBody = root.querySelector('[data-ns-chart-body]');
  var dlgTitle = root.querySelector('[data-ns-chart-title]');
  var chartCache = {};

  function chartUrl(c) {
    var base = root.getAttribute('data-root') || '/';
    return base + 'apps/sizemind/size-chart?shop=' + encodeURIComponent(root.getAttribute('data-shop') || '') +
      '&productId=' + encodeURIComponent(c.el.getAttribute('data-pid')) +
      '&productType=' + encodeURIComponent(c.el.getAttribute('data-ptype') || '') +
      '&tags=' + encodeURIComponent(c.el.getAttribute('data-tags') || '');
  }
  function stockKey(s) { return String(s || '').toUpperCase().replace(/\s+/g, ''); }

  function chartHtml(c, ch) {
    var col = c.colors[c.color] || { sizes: [], name: '' };
    var inStock = {};
    col.sizes.forEach(function (s) { inStock[stockKey(s.s)] = true; });
    function mark(name) {
      var on = inStock[stockKey(name)];
      return '<span class="n-ns-chart__st' + (on ? ' is-on' : '') + '">' + (on ? 'na stanju' : 'u dolasku') + '</span>';
    }
    var head = '<p class="n-ns-chart__note">Mjere tijela u ' + esc(ch.measurementUnit || 'cm') + (col.name ? ' · boja: ' + esc(col.name) : '') + '</p>';
    if (ch.braTable && ch.braTable.length) {
      var order = [], by = {};
      ch.braTable.forEach(function (r) {
        if (!by[r.sizeName]) { by[r.sizeName] = []; order.push(r.sizeName); }
        by[r.sizeName].push(String(r.band) + r.cup);
      });
      return head + '<table class="n-ns-chart__t"><thead><tr><th>Vel.</th><th>Vaš broj grudnjaka</th><th></th></tr></thead><tbody>' +
        order.map(function (n) { return '<tr><th>' + esc(n) + '</th><td>' + esc(by[n].join(', ')) + '</td><td>' + mark(n) + '</td></tr>'; }).join('') +
        '</tbody></table>';
    }
    var cols = [['Chest', 'Grudi'], ['Waist', 'Struk'], ['Hips', 'Bokovi'], ['Height', 'Visina']].filter(function (k) {
      return (ch.entries || []).some(function (e) { return e['min' + k[0]] != null; });
    });
    return head + '<table class="n-ns-chart__t"><thead><tr><th>Vel.</th>' + cols.map(function (k) { return '<th>' + k[1] + '</th>'; }).join('') + '<th></th></tr></thead><tbody>' +
      (ch.entries || []).map(function (e) {
        return '<tr><th>' + esc(e.sizeName) + '</th>' + cols.map(function (k) {
          var a = e['min' + k[0]], b = e['max' + k[0]];
          return '<td>' + (a == null ? '–' : esc(a) + (b != null && b !== a ? '–' + esc(b) : '')) + '</td>';
        }).join('') + '<td>' + mark(e.sizeName) + '</td></tr>';
      }).join('') + '</tbody></table>';
  }

  function fallbackHtml(c) {
    var href = c.links.length ? c.links[0].getAttribute('href') : '#';
    return '<p class="n-ns-chart__note">Tabela za ovaj model je na stranici proizvoda.</p><a class="n-link" href="' + esc(href) + '">Otvori proizvod i tabelu →</a>';
  }

  function openChart(c) {
    if (!dlg) return;
    var title = c.el.querySelector('.n-ns-card__title');
    if (dlgTitle) dlgTitle.textContent = 'Tabela veličina — ' + (title ? title.textContent.trim() : '');
    dlgBody.innerHTML = '<p class="n-ns-chart__note">Učitavam…</p>';
    if (dlg.showModal) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } } else dlg.setAttribute('open', '');
    var pid = c.el.getAttribute('data-pid');
    var p = chartCache[pid] || (chartCache[pid] = fetch(chartUrl(c)).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
    p.then(function (d) {
      var ch = d && d.success && d.sizeChart;
      var ok = ch && ((ch.entries && ch.entries.length) || (ch.braTable && ch.braTable.length));
      dlgBody.innerHTML = ok ? chartHtml(c, ch) : fallbackHtml(c);
    });
  }
  if (dlg) {
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-ns-chart-close]')) {
        if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
      }
    });
  }

  apply();
})();
